import GRRHModuleLayout from "@features/rh/components/GRRHModuleLayout";
import { requireHRManagementAccess } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

/**
 * RH Module Route
 *
 * Access requires HR management-level permissions (rh.* without :scope:self).
 * Plain employees (scope:self only) are excluded - they should access /my routes instead.
 *
 * Allowed profiles: Admin, DRH, Responsable Département, Chef d'Équipe, Manager Multi-filiale, Auditeur
 * Excluded profiles: Employé Standard (scope:self only)
 */
export const Route = createFileRoute("/_app/rh")({
  loader: requireHRManagementAccess({ redirectTo: "/unauthorized" }),
  staticData: {
    title: "RH",
    permission: PERMISSIONS.RH.PERSONNE.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 10,
    showInNav: true,
  },
  component: GRRHModuleLayout,
});
